import { cva, VariantProps } from 'class-variance-authority'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib/style'

import { TContractStatus, ZContractStatus } from '../model/schema'

const STATUS_BADGE_BASE_STYLES =
  'typo-caption2 min-w-11.5 rounded-xs px-1 py-[3px] text-center font-semibold select-none text-white'

const statusBadgeVariants = cva([STATUS_BADGE_BASE_STYLES], {
  variants: {
    status: {
      [ZContractStatus.enum.APPROVE_READY]: 'bg-gray-700 text-white',
      [ZContractStatus.enum.PAY_READY]: 'bg-gray-700 text-white',
      [ZContractStatus.enum.CONTRACT_COMPLETE]: 'bg-gray-100 text-gray-900',
      [ZContractStatus.enum.CANCEL]: 'bg-gray-200 text-gray-500',
      [ZContractStatus.enum.REFUND]: 'bg-gray-200 text-gray-500',
    },
    highlight: {
      true: 'bg-purple-500 text-white',
    },
  },
})

type Props = ComponentProps<'span'> &
  VariantProps<typeof statusBadgeVariants> & {
    status: TContractStatus
    highlight?: boolean
  }

export const ContractStatusBadge = ({
  className,
  status,
  highlight,
  children,
  ...props
}: Props) => {
  const t = useTranslations('guest_lease_list.contract.status')

  const statusTextMap: Record<TContractStatus, string> = {
    [ZContractStatus.enum.APPROVE_READY]: t('approval_pending'),
    [ZContractStatus.enum.PAY_READY]: t('payment_pending'),
    [ZContractStatus.enum.CONTRACT_COMPLETE]: t('payment_completed'),
    [ZContractStatus.enum.CANCEL]: t('canceled'),
    [ZContractStatus.enum.REFUND]: t('payment_canceled'),
  }

  return (
    <span
      className={cn(statusBadgeVariants({ status, highlight }), className)}
      {...props}
    >
      {children ?? statusTextMap[status]}
    </span>
  )
}

export const ExtendedContractStatusBadge = ({
  className,
  ...props
}: ComponentProps<'span'>) => {
  return (
    <span
      className={cn(STATUS_BADGE_BASE_STYLES, className)}
      {...props}
      style={{
        background:
          'linear-gradient(290deg, rgba(2, 209, 255, 0.00) 28.54%, #02D1FF 152.38%), #2375F6',
      }}
    >
      연장
    </span>
  )
}
